import PropTypes from "prop-types";
export const userShape = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    role: PropTypes.string,
});

export const tourneeShape = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string,
});

export const ehpadShape = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    code: PropTypes.string,
    nom: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    tournee: PropTypes.string,
    tourneeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    emailsContact: PropTypes.arrayOf(PropTypes.string),
    emailsFax: PropTypes.arrayOf(PropTypes.string),
});
